import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { ArrowUpCircle } from 'react-bootstrap-icons';
import { Organization } from '../../../models';
import { parseBillingPeriodEnd } from '../../../utils/billingPeriodEnd';

interface TrialBannerProps {
  organization: Organization | null;
}

function daysRemaining(endDate: Date): number {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);
  const diff = Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  return Math.max(0, diff);
}

const TrialBanner: React.FC<TrialBannerProps> = ({ organization }) => {
  const navigate = useNavigate();
  const [daysLeft, setDaysLeft] = useState<number | null>(null);

  const isTrialing = organization?.billing?.subscriptionStatus === 'trialing';
  const endRaw = organization?.billing?.currentPeriodEnd;

  useEffect(() => {
    if (!isTrialing || !endRaw) return;
    const endDate = parseBillingPeriodEnd(endRaw);
    if (!endDate) return;
    setDaysLeft(daysRemaining(endDate));

    const interval = setInterval(() => {
      setDaysLeft(daysRemaining(endDate));
    }, 60_000); // refresh every minute
    return () => clearInterval(interval);
  }, [isTrialing, endRaw]);

  if (!isTrialing || daysLeft === null) return null;

  return (
    <Alert
      variant="info"
      className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3 py-2 px-3"
    >
      <span>
        <strong>Prueba gratuita</strong>
        {' · '}
        {daysLeft === 0
          ? 'Termina hoy'
          : daysLeft === 1
            ? '1 día restante'
            : `${daysLeft} días restantes`}
      </span>
      <Button
        variant="outline-primary"
        size="sm"
        onClick={() => navigate('/paywall')}
      >
        <ArrowUpCircle size={16} className="me-1" />
        Actualizar plan
      </Button>
    </Alert>
  );
};

export default TrialBanner;
